/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateResourceLockRequest {
    getFixupPrototypeFunction() { return CreateResourceLockRequest.fixupPrototype; }

    static newInstance(model: Partial<CreateResourceLockRequest>): CreateResourceLockRequest {
        let obj = Object.assign(new CreateResourceLockRequest(), model);
        CreateResourceLockRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateResourceLockRequest>): CreateResourceLockRequest {
        if (!model) return null;
        return CreateResourceLockRequest.newInstance(<CreateResourceLockRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateResourceLockRequest) {
        if (!obj) return;

        models.CreateResourceLockRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateResourceLockRequest): boolean {
        Object.setPrototypeOf(obj, CreateResourceLockRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            for (let val of this.filters) {
                models.CreateLockFilterRequest.fixupPrototype(val);
            }
        }
    }

    /**
     * cloud_acccount_id
     */
    cloud_account_id: string;

    /**
     * cloud_account_name
     */
    cloud_account_name: string;

    /**
     * The category will be either service or resource
     */
    cloud: string;

    /**
     * Displays the list of tenant ids
     */
    tenant_ids: Array<string>;

    /**
     * Account Scope - For account scope,user can apply lock to particular cloud account,Tenant Scope - Users with tenant can apply lock for multiple tenants., allowed values are tenant, cloud_account
     */
    scope: string;

    /**
     * filters for cloud _account_scope
     */
    filters: Array<models.CreateLockFilterRequest>;

    /**
     * lock type
     */
    lock_type: string;

    /**
     * config rule id to enable/disable config rule
     */
    config_rule_id: string;

    /**
     * action to enable/disable config rule. allowed values are enable or diable
     */
    action: string;

}
